import { BrowserRouter, useLocation } from "react-router-dom";
import Routes from "./Routes";
import "./app.css";
import { useEffect } from "react";

function App() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </div>
  );
}

export default App;
